import { createMuiTheme } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
var theme = createMuiTheme({
    palette: {
        primary: {
            main: '#F29E25',
        },
        text: {
            disabled: grey[500],
            secondary: grey[900],
        },
        action: {
            disabled: grey[500],
        },
        warning: {
            main: '#c62828',
        },
        error: {
            main: '#ff0000',
            100: '#ffeeeee6',
        },
    },
    shape: {
        borderRadius: 3,
    },
    typography: {
        fontSize: 12,
        htmlFontSize: 13,
        fontFamily: 'Arial',
    },
    commonSettings: {
        inputHeight: 24,
        borderColor: grey[500],
        disabledColor: grey[500],
    },
});
export default theme;
//# sourceMappingURL=theme.js.map